import { render, staticRenderFns } from "./DecorationDialog.vue?vue&type=template&id=49da5021"
import script from "./DecorationDialog.vue?vue&type=script&lang=js"
export * from "./DecorationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports